import EpisodeItem from "./EpisodeItem";

export default EpisodeItem;
